module.exports = __webpack_public_path__ + "static/media/vistosa.cc95b99d.png";